module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "basic-info"
  }, [(['fromWX', 'fromBD', 'fromZFB', 'fromTT'].indexOf(_vm.pagefrom) === -1 && (_vm.resumeType === 2 && !_vm.isLogin)) ? _c('login-guide') : _vm._e(), _vm._v(" "), _c('head-portrait'), _vm._v(" "), _c('div', {
    staticClass: "basic-info-box"
  }, [_c('name', {
    ref: "truename"
  }), _vm._v(" "), _c('sex', {
    ref: "gender"
  }), _vm._v(" "), _c('mobile', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    ref: "mobile"
  }), _vm._v(" "), _c('login-captcha', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    ref: "loginMobile"
  }), _vm._v(" "), _c('experience', {
    ref: "experience"
  })], 1), _vm._v(" "), (_vm.needEducation) ? _c('div', {
    staticClass: "basic-education"
  }, [_c('my-education')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "basic-info-save-box"
  }, [_c('div', {
    staticClass: "page-btn",
    class: {
      'btn-disabled': !_vm.basicInfoOk
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("保存")])]), _vm._v(" "), _c('toast', {
    attrs: {
      "time": _vm.time
    },
    model: {
      value: (_vm.errorTip),
      callback: function($$v) {
        _vm.errorTip = $$v
      },
      expression: "errorTip"
    }
  }, [_vm._v(_vm._s(_vm.errorInfo))]), _vm._v(" "), (_vm.showStay) ? _c('my-dialog', {
    attrs: {
      "title": "提示",
      "content": "离好工作仅差一步，是否确认退出？",
      "btnCancel": "确定退出",
      "btnConfirm": "继续填写"
    },
    on: {
      "cancel": _vm.quit,
      "confirm": _vm.noQuit
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showLimit) ? _c('my-dialog', {
    attrs: {
      "title": "提示",
      "content": "您的简历已达到上限了哦",
      "btnCancel": "查看职位",
      "btnConfirm": "查看简历"
    },
    on: {
      "cancel": _vm.goJobList,
      "confirm": _vm.goMyResume
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b2560f8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/module/basic/components/basic/index.vue
// module id = 350
// module chunks = 0